var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row no-gutters historical-batch-container" },
    [
      _c(
        "div",
        {
          staticClass:
            "col-3 dmv-text text-center pt-4 historical-batch-information"
        },
        [
          _c("span", { staticClass: "dmv-text-secondary" }, [
            _vm._v(
              _vm._s(
                _vm.resource(
                  "DmVisualizer_ScenarioHistoricalOverview_Period_Label"
                )
              ) + ":"
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.formattedFrom))]),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n        -\n        "),
          _c("br"),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.formattedTo))]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "dmv-text-secondary" }, [
            _vm._v(
              _vm._s(
                _vm.resource(
                  "DmVisualizer_ScenarioHistoricalOverview_TargetDate_Label"
                )
              ) + ":"
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.formattedTarget))]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "fa fa-bar-chart-o fa-3x" }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "dmv-text dmv-link dmv-text-secondary",
              attrs: { href: _vm.dashboardUrl }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.resource(
                    "DmVisualizer_ScenarioHistoricalOverview_DashboardLink_Label"
                  )
                )
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col border historical-batch-table-container" },
        [
          _c(
            "table",
            { staticClass: "table table-striped historical-batch-table" },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { colspan: "2" } }, [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      _vm._s(
                        _vm.resource(
                          "DmvHistoricalBatchListModel_Costs_DisplayName"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      _vm._s(
                        _vm.resource(
                          "DmvHistoricalBatchListModel_Recipients_DisplayName"
                        )
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.sortedScenarios, function(scenario) {
                  return _c("tr", { key: scenario.scenarioId }, [
                    _c("td", [
                      _c(
                        "span",
                        { staticClass: "dmv-text dmv-text-secondary" },
                        [_vm._v(_vm._s(scenario.name))]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "scenario-image-container" }, [
                        scenario.imageUrl
                          ? _c("img", {
                              staticClass: "scenario-image",
                              attrs: { src: scenario.imageUrl }
                            })
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "dmv-text dmv-text-primary" }, [
                        _vm._v(
                          "€ " +
                            _vm._s(
                              _vm.aggregatedScenarioValues[scenario.scenarioId]
                                .costs
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "span",
                        {
                          staticClass:
                            "dmv-text dmv-text-primary dmv-text-medium-large text-bold"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.aggregatedScenarioValues[scenario.scenarioId]
                                .recipients
                            )
                          )
                        ]
                      )
                    ])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "span",
                      {
                        staticClass: "dmv-text dmv-text-large dmv-text-primary"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.resource(
                              "DmVisualizer_ScenarioHistoricalOverview_Totals_Label"
                            )
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "span",
                      {
                        staticClass:
                          "dmv-text dmv-text-medium-large dmv-text-primary"
                      },
                      [_vm._v("€ " + _vm._s(_vm.totalCosts))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "span",
                      {
                        staticClass:
                          "dmv-text dmv-text-large dmv-text-primary text-bold"
                      },
                      [_vm._v(_vm._s(_vm.totalRecipients))]
                    )
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }